<main class="color-scheme-dark">
  <div class="login-theme-wrapper">
    <!-- Navigation / Language / Small Logo -->
    <nav class="lang-select-nav">
      <div>
        <img class="ugm-logo" width="45px" src="../../../assets/logos/logo_ugm.svg" alt="15C" />
      </div>
      <div>
        <span>
          <mat-icon style="vertical-align: middle; margin-right: 4px; font-size: 18px">language</mat-icon>
          <select #selectedLang (change)="switchLang(selectedLang.value); user.saveLang(selectedLang.value)">
            <option [value]="'pt-br'" [selected]="translate.currentLang === 'pt-br'">Português</option>
            <option [value]="'en'" [selected]="translate.currentLang === 'en'">English</option>
            <option [value]="'es'" [selected]="translate.currentLang === 'es'">Español</option>
          </select>
        </span>
      </div>
    </nav>

    <div class="brand-panel">
      @if (isLoading) {
        <app-pantera-runner class="runner" />
      } @else {
        <img src="../../../assets/logos/pantera_head_negative.svg" class="ugm-logo-hero" alt="Pantera" />
      }
    </div>

    <div class="form-panel">
      <div class="login-container">
        @if (isDev) {
          <div class="dev-alert-banner">
            <mat-icon>warning</mat-icon>
            <div class="dev-alert-text">
              <strong>{{ 'MAP.DEV_ALERT_TITLE' | translate }}</strong>
              <span>{{ 'MAP.DEV_ALERT_DESCRIPTION' | translate }}</span>
            </div>
          </div>
        }
        @if (feedbackMessage.type) {
          <div
            class="feedback-container"
            [class.feedback-error]="feedbackMessage.type === 'error'"
            [class.feedback-success]="feedbackMessage.type === 'success'"
          >
            <mat-icon>{{ feedbackMessage.type === 'error' ? 'error_outline' : 'check_circle_outline' }}</mat-icon>
            <span>{{ feedbackMessage.key | translate }}</span>
          </div>
        }
        @if (isLoading) {
          <div class="loading-overlay"></div>
        }
        @if (loginService.wrongMfa()) {
          <h3>
            <mat-icon color="warn">error_outline</mat-icon>
            {{ 'MAP.WRONG_MFA' | translate }}
          </h3>
        }
        @if (loginService.mfaExpired()) {
          <h3>
            <mat-icon color="warn">error_outline</mat-icon>
            {{ 'MAP.EXPIRED_MFA' | translate }}
          </h3>
        }
        @if (!isMfaRequired) {
          <ng-container>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>
                {{ 'MAP.USERNAME' | translate }}
              </mat-label>
              <input matInput [(ngModel)]="username" (change)="showErrorMessage = false" />
              <mat-icon matSuffix>account_circle</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" color="primary">
              <mat-label>
                {{ 'MAP.PASSWORD' | translate }}
              </mat-label>
              <input
                matInput
                [type]="showPass ? 'text' : 'password'"
                [(ngModel)]="userpass"
                (keyup.enter)="sign_in()"
              />
              <button mat-icon-button matSuffix (click)="showPass = !showPass">
                <mat-icon>{{ showPass ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
            </mat-form-field>

            <div class="check-box-container">
              <mat-checkbox color="primary" [(ngModel)]="rememberMe">
                {{ 'MAP.REMEMBER_ME' | translate }}
              </mat-checkbox>

              <button type="button" class="forgot-pass" (click)="forgot_pass()">
                {{ 'MAP.FORGOT_PASSWORD' | translate }}
              </button>
            </div>

            <button mat-raised-button class="login-btn" color="primary" (click)="sign_in()">
              {{ 'MAP.SIGN_IN' | translate }}
            </button>

            <button type="button" class="forgot-pass sso-login-link" (click)="login_sso()">
              {{ 'MAP.SIGN_IN_MICROSOFT' | translate }}
            </button>
          </ng-container>
        } @else {
          <ng-container>
            <p style="color: white; margin-bottom: 1rem; text-align: center">{{ 'MAP.ENTER_MFA_CODE' | translate }}</p>
            <p style="color: rgba(255, 255, 255, 0.7); font-size: 0.9rem; text-align: center; margin-bottom: 1.5rem">
              {{ 'MAP.MFA_CODE_SENT' | translate }}
              <strong style="color: white">{{ hiddenEmail }}</strong>
            </p>

            <mat-form-field appearance="outline" color="primary">
              <mat-label>{{ 'MAP.MFA_CODE' | translate }}</mat-label>
              <span matPrefix>
                <mat-icon>security</mat-icon>
                &nbsp;
              </span>
              <input
                matInput
                [(ngModel)]="mfaCode"
                maxlength="6"
                (input)="mfaCode = mfaCode?.slice(0, 6)"
                (keydown.space)="$event.preventDefault()"
                (keyup.enter)="submitMfaCode()"
              />
            </mat-form-field>

            <div class="check-box-container" style="justify-content: center; margin-bottom: 1rem">
              @if (countDownCheck()) {
                <span style="color: rgba(255, 255, 255, 0.7)">{{ 'MAP.NEW_MFA' | translate }} {{ countdown() }}</span>
              } @else {
                <span (click)="resendMfaCode()" class="new-code">{{ 'MAP.REQUEST_NEW_CODE' | translate }}</span>
              }
            </div>

            @if (!loginService.mfaExpired()) {
              <button
                [disabled]="$safeNavigationMigration(mfaCode?.length) < 6"
                mat-raised-button
                class="login-btn"
                color="warn"
                (click)="submitMfaCode()"
              >
                {{ 'MAP.SIGN_IN' | translate }}
              </button>
            } @else {
              <button mat-raised-button class="login-btn" color="warn" (click)="sign_in()">
                {{ 'MAP.RESEND_CODE' | translate }}
              </button>
            }
          </ng-container>
        }
      </div>

      <span class="login-footnote">© 2026 - Pantera® v{{ version }}</span>
    </div>
  </div>
</main>
